export const COPAY_COMPLETED_CLAIMS_TABLE = [ 
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: '',
    label: 'Patient',
  },
  {
    value:'',
    label:'Product'
  },
  {
    value:'',
    label:'Submitting Practice'
  },
  {
    value:'',
    label:'Claim Status'
  },
  {
    value:'',
    label:'Paid Claim Amount'
  },
  {
    value:'',
    label:'Paid Claim Date'
  },
  {
    value:'',
    label:'Remaining Co-Pay Benefit Available'
  }
];
